import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const containerStyling: AbgSxProps = {
  width: '100%',
};

export const contentWrapperStyling: AbgSxProps = {
  padding: { xs: '56px 16px 2px', sm: '56px 56px 42px' },
  flexDirection: 'column',
  gap: { xs: '32px', sm: '56px' },
};

export const contentStyling: AbgSxProps = {
  flexDirection: 'column',
  gap: '6px',
};

export const footerStyling: AbgSxProps = {
  color: paletteBase.secondary400,
  textAlign: 'center',
};
